module.exports = __webpack_public_path__ + "img/house-window.73bb6dc6.svg";